import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
`;

export const ImageContainer = styled.div`
	cursor: pointer;
	position: relative;
	display: inline-block;

	&:hover {
		img {
			transform: scale(0.8);
			opacity: 0.8;
		}
	}
`;

export const DCImage = styled.div`
	object-fit: contain;
`;
